import { IButton } from "../../interfaces";
import { gaButtonClassNameMap } from "../../utils/gaiaUtils";

export const GaButton = ({ onclick, onKeyDown, text, title, className, disabled, dataTestId, children }: IButton) => {
    
    const gaButtonClassName = (() => {
        if (!className) return "ga-button ga-button--secondary";

        const matchingKey = Object.keys(gaButtonClassNameMap).find((key) =>
            className.startsWith(key)
        );

        return matchingKey
            ? gaButtonClassNameMap[matchingKey] : "ga-button ga-button--secondary";
    })();

    return (
        <>
            <button
                className={`${gaButtonClassName}`}
                onClick={onclick}
                onKeyDown={onKeyDown}
                title={title}
                disabled={disabled}
                data-testid={dataTestId}
            >
                {text}
                {children}
        </button>
        </>
    )
}